import ReactPaginate from "react-paginate"

const Pagination = ({ handlePageClick , lastPage ,options }) => {
    return (
        <div className="flex justify-center w-full py-4">
            <ReactPaginate
                {
                    ...options
                }
                containerClassName="pagination"
                breakLabel="..."
                nextLabel="بعدی"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}  
                marginPagesDisplayed={1}
                activeClassName="text-[#F1CE46] bg-[#0B231E] !px-3 rounded-lg shadow-lg mx-2 "
                previousClassName="bg-[#001a2b] px-5 py-2 rounded-xl text-white"
                nextClassName="bg-[#001a2b] px-5 py-2 rounded-xl text-white"
                pageCount={lastPage}
                disabledClassName="!hidden"
                previousLabel="قبلی"
                renderOnZeroPageCount={null}
            />
        </div>
    )
}

export default Pagination